import { Service } from '@jcd-web/basic-service';
import { DonationApi } from './DonationApi';
export class DonationService extends Service {
    static donate(donation) {
        return DonationApi.donate(donation).then(r => {
            return r;
        });
    }
}
